<script setup>
import Button from "primevue/button";
import { useRouter } from "vue-router";

const router = useRouter();

function redirectHome() {
  router.push({ name: "Home" });
}
</script>

<template>
  <div class="not-found-container">
    <div class="background-animation">
      <div id="bg-gradient-1"></div>
      <div id="bg-gradient-2"></div>
      <div id="bg-gradient-3"></div>
    </div>
    <div class="not-found-content">
      <i class="pi pi-exclamation-triangle not-found-icon"></i>
      <h1>404</h1>
      <h2>Página não encontrada</h2>
      <p>A página que você está procurando não existe.</p>
      <Button
        label="Voltar para Home"
        icon="pi pi-home"
        @click="redirectHome"
        class="mt-4"
      />
    </div>
  </div>
</template>

<style scoped>
.not-found-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.background-animation {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  pointer-events: none;
}

.background-animation div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  animation-name: fade;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-duration: 16s;
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  40% {
    opacity: 1;
  }
  60% {
    opacity: 0;
  }
  80% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

#bg-gradient-1 {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #f1f5f9 100%);
}

#bg-gradient-2 {
  background: linear-gradient(135deg, #fef7f0 0%, #fed7aa 50%, #f97316 100%);
  animation-delay: -4s;
}

#bg-gradient-3 {
  background: linear-gradient(135deg, #f0f9ff 0%, #bae6fd 50%, #0ea5e9 100%);
  animation-delay: -8s;
}

.not-found-content {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 16px;
  padding: 48px 40px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  max-width: 500px;
  width: 100%;
  text-align: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
}

.not-found-icon {
  font-size: 4rem;
  color: #dc2626;
  margin-bottom: 16px;
}

h1 {
  font-size: 4rem;
  font-weight: 700;
  background: linear-gradient(135deg, #f5631a 0%, #e84910 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
  letter-spacing: -0.02em;
}

h2 {
  font-size: 1.75rem;
  font-weight: 600;
  color: #111827;
  margin: 16px 0 8px 0;
  letter-spacing: -0.01em;
}

p {
  color: #6b7280;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
}

@media (max-width: 480px) {
  .not-found-content {
    padding: 32px 24px;
  }

  h1 {
    font-size: 3rem;
  }

  h2 {
    font-size: 1.5rem;
  }
}
</style>
